<template>
    <div>
        <table class="w-full">
            <thead class="sticky top-0 z-20 bg-white">
                <tr class="flex w-full">
                    <th class="sticky left-0 z-30 flex items-center justify-center flex-shrink-0 w-12 p-2 overflow-hidden text-sm font-bold text-center border-b border-r border-solid sm:w-40 border-neutral-200 h-11 bg-neutral-100 text-neutral-600">
                        Bruger
                    </th>
                    <th v-for="eventType in eventTypes" :key="eventType"
                        class="flex items-center justify-center flex-shrink-0 w-20 p-2 overflow-hidden text-sm font-bold text-center border-b border-r border-solid sm:w-36 border-neutral-200 h-11 bg-neutral-100 text-neutral-600">
                        <span class="truncate" :title="eventType">{{ eventType }}</span>
                    </th>
                    <th class="flex items-center justify-center flex-grow p-2 overflow-hidden text-sm font-bold text-center border-b border-solid border-neutral-200 h-11 bg-neutral-100 text-neutral-600">
                        Total
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.id" class="flex group hover:bg-neutral-50">
                    <td class="sticky left-0 z-10 flex-shrink-0 w-12 text-sm bg-white border-b border-r border-solid cursor-pointer sm:w-40 group-hover:bg-neutral-50 sticky-column border-neutral-200"
                        @mouseover="showUserInfo(user, $event)" @mouseleave="$emit('hide-user-info')">
                        <div class="px-2 w-full h-full overflow-hidden text-ellipsis whitespace-nowrap leading-[2.75rem]"
                            :title="user.first_name + ' ' + user.last_name">
                            <span class="sm:hidden">{{ usersStore.getUserInitials(user) }}</span>
                            <span class="hidden sm:inline">{{ user.first_name + " " + user.last_name }}</span>
                        </div>
                    </td>
                    <td v-for="eventType in eventTypes" :key="eventType"
                        class="flex items-center justify-center flex-shrink-0 w-20 p-2 text-lg font-bold border-b border-r border-solid sm:w-36 border-neutral-200">
                        {{ getUserEventCount(user, eventType) }}
                    </td>
                    <td class="flex items-center justify-center flex-grow p-2 text-lg font-bold border-b border-solid border-neutral-200">
                        {{ getUserTotalEventCount(user) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { useEventsStore } from '@/stores/eventsStore';
import { useUsersStore } from '@/stores/usersStore';

const props = defineProps({
    users: {
        type: Array,
        required: true,
    },
    startDate: {
        type: Date,
        required: true,
    },
    endDate: {
        type: Date,
        required: true,
    },
});

const emit = defineEmits(['show-user-info', 'hide-user-info']);

const eventsStore = useEventsStore();
const usersStore = useUsersStore();

const eventTypes = computed(() => eventsStore.getAllEventTypes);

function getUserEventCount(user, eventType) {
    return user.events.filter(event =>
        event.type === eventType &&
        new Date(event.date) >= props.startDate &&
        new Date(event.date) <= props.endDate
    ).length;
}

function getUserTotalEventCount(user) {
    return eventTypes.value.reduce((total, eventType) => {
        return total + getUserEventCount(user, eventType);
    }, 0);
}

function showUserInfo(user, event) {
    emit('show-user-info', user, event.clientX, event.clientY);
}
</script>